<template>
  <div class="mobile-navigation">
    <btn-wrapper
        v-for="(item, index) in nav"
        :key="index"
        :params="{
                activeClass: 'mobile-navigation__item_active',
                class: 'mobile-navigation__item stroke-black',
                type: 'link',
                path: `${item.path}`,
                // isSlotIsset: true,
          }"
    >
      <div class="mobile-navigation__icon">
        <svg class="icon">
          <use :xlink:href="item.icon"></use>
        </svg>
      </div>
    </btn-wrapper>
  </div>
</template>

<script>
export default {
  name: 'MobileNavigation',
  data: () => ({
    nav: [
      // {
      //   icon: '/img/sprites/icons-sprite.svg#icon-home',
      //   path: '/home',
      // },
      {
        icon: '/img/sprites/icons-sprite.svg#icon-user',
        path: '/cabinet',
      },
      {
          icon: '/img/sprites/icons-sprite.svg#icon-calendar',
          path: '/calendar',
      },
      {
        icon: '/img/sprites/icons-sprite.svg#icon-course',
        path: '/courses',
      }
    ]
  })
}
</script>

<style lang="scss" scoped>
@import './scss/mobile-navigation.scss';
</style>
